class Config {
}

// eslint-disable-next-line
Config.env = PublicConfig.env

Config.restUrl = Config.env === 'dev' ? 'https://test-bus.uu1.com/' : 'https://bus.uu1.com/'
// Config.restUrl = Config.env === 'dev' ? '/api/' : 'http://bus.uu1.com/'
Config.onPay = true // 是否启用支付

Config.clientSecret = Config.env === 'dev' ? 'czcqMvc2016' : 'js.admin@2020'

Config.clientId = Config.env === 'dev' ? 'czcqMvc' : 'js.admin'

export { Config }
